import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { BroadcasterResult } from "./BroadcasterResult";
import { ObjectUtils } from "../util/ObjectUtils";
/**
 * Broadcaster provides a helper methods to broadcast events to the subscribers.
 */
export var Broadcaster = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function Broadcaster(queryRunner) {
    _classCallCheck(this, Broadcaster);
    this.queryRunner = queryRunner;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  _createClass(Broadcaster, [{
    key: "broadcast",
    value: function () {
      var _broadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var result,
          broadcastFunction,
          _len,
          args,
          _key,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              result = new BroadcasterResult();
              broadcastFunction = this["broadcast".concat(event, "Event")];
              if (typeof broadcastFunction === "function") {
                ;
                for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = _args[_key];
                }
                broadcastFunction.call.apply(broadcastFunction, [this, result].concat(args));
              }
              _context.next = 5;
              return result.wait();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function broadcast(_x) {
        return _broadcast.apply(this, arguments);
      }
      return broadcast;
    }()
    /**
     * Broadcasts "BEFORE_INSERT" event.
     * Before insert event is executed before entity is being inserted to the database for the first time.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastBeforeInsertEvent",
    value: function broadcastBeforeInsertEvent(result, metadata, entity) {
      var _this = this;
      if (entity && metadata.beforeInsertListeners.length) {
        metadata.beforeInsertListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this.isAllowedSubscriber(subscriber, metadata.target) && subscriber.beforeInsert) {
            var executionResult = subscriber.beforeInsert({
              connection: _this.queryRunner.connection,
              queryRunner: _this.queryRunner,
              manager: _this.queryRunner.manager,
              entity: entity,
              metadata: metadata
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_UPDATE" event.
     * Before update event is executed before entity is being updated in the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastBeforeUpdateEvent",
    value: function broadcastBeforeUpdateEvent(result, metadata, entity, databaseEntity, updatedColumns, updatedRelations) {
      var _this2 = this;
      // todo: send relations too?
      if (entity && metadata.beforeUpdateListeners.length) {
        metadata.beforeUpdateListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this2.isAllowedSubscriber(subscriber, metadata.target) && subscriber.beforeUpdate) {
            var executionResult = subscriber.beforeUpdate({
              connection: _this2.queryRunner.connection,
              queryRunner: _this2.queryRunner,
              manager: _this2.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              updatedColumns: updatedColumns || [],
              updatedRelations: updatedRelations || []
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_REMOVE" event.
     * Before remove event is executed before entity is being removed from the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastBeforeRemoveEvent",
    value: function broadcastBeforeRemoveEvent(result, metadata, entity, databaseEntity) {
      var _this3 = this;
      if (entity && metadata.beforeRemoveListeners.length) {
        metadata.beforeRemoveListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this3.isAllowedSubscriber(subscriber, metadata.target) && subscriber.beforeRemove) {
            var executionResult = subscriber.beforeRemove({
              connection: _this3.queryRunner.connection,
              queryRunner: _this3.queryRunner,
              manager: _this3.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              entityId: metadata.getEntityIdMixedMap(databaseEntity)
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_SOFT_REMOVE" event.
     * Before soft remove event is executed before entity is being soft removed from the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastBeforeSoftRemoveEvent",
    value: function broadcastBeforeSoftRemoveEvent(result, metadata, entity, databaseEntity) {
      var _this4 = this;
      if (entity && metadata.beforeSoftRemoveListeners.length) {
        metadata.beforeSoftRemoveListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this4.isAllowedSubscriber(subscriber, metadata.target) && subscriber.beforeSoftRemove) {
            var executionResult = subscriber.beforeSoftRemove({
              connection: _this4.queryRunner.connection,
              queryRunner: _this4.queryRunner,
              manager: _this4.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              entityId: metadata.getEntityIdMixedMap(databaseEntity)
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_RECOVER" event.
     * Before recover event is executed before entity is being recovered in the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastBeforeRecoverEvent",
    value: function broadcastBeforeRecoverEvent(result, metadata, entity, databaseEntity) {
      var _this5 = this;
      if (entity && metadata.beforeRecoverListeners.length) {
        metadata.beforeRecoverListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this5.isAllowedSubscriber(subscriber, metadata.target) && subscriber.beforeRecover) {
            var executionResult = subscriber.beforeRecover({
              connection: _this5.queryRunner.connection,
              queryRunner: _this5.queryRunner,
              manager: _this5.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              entityId: metadata.getEntityIdMixedMap(databaseEntity)
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_INSERT" event.
     * After insert event is executed after entity is being persisted to the database for the first time.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastAfterInsertEvent",
    value: function broadcastAfterInsertEvent(result, metadata, entity) {
      var _this6 = this;
      if (entity && metadata.afterInsertListeners.length) {
        metadata.afterInsertListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this6.isAllowedSubscriber(subscriber, metadata.target) && subscriber.afterInsert) {
            var executionResult = subscriber.afterInsert({
              connection: _this6.queryRunner.connection,
              queryRunner: _this6.queryRunner,
              manager: _this6.queryRunner.manager,
              entity: entity,
              metadata: metadata
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_TRANSACTION_START" event.
     */
  }, {
    key: "broadcastBeforeTransactionStartEvent",
    value: function broadcastBeforeTransactionStartEvent(result) {
      var _this7 = this;
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (subscriber.beforeTransactionStart) {
            var executionResult = subscriber.beforeTransactionStart({
              connection: _this7.queryRunner.connection,
              queryRunner: _this7.queryRunner,
              manager: _this7.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_TRANSACTION_START" event.
     */
  }, {
    key: "broadcastAfterTransactionStartEvent",
    value: function broadcastAfterTransactionStartEvent(result) {
      var _this8 = this;
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (subscriber.afterTransactionStart) {
            var executionResult = subscriber.afterTransactionStart({
              connection: _this8.queryRunner.connection,
              queryRunner: _this8.queryRunner,
              manager: _this8.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_TRANSACTION_COMMIT" event.
     */
  }, {
    key: "broadcastBeforeTransactionCommitEvent",
    value: function broadcastBeforeTransactionCommitEvent(result) {
      var _this9 = this;
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (subscriber.beforeTransactionCommit) {
            var executionResult = subscriber.beforeTransactionCommit({
              connection: _this9.queryRunner.connection,
              queryRunner: _this9.queryRunner,
              manager: _this9.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_TRANSACTION_COMMIT" event.
     */
  }, {
    key: "broadcastAfterTransactionCommitEvent",
    value: function broadcastAfterTransactionCommitEvent(result) {
      var _this10 = this;
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (subscriber.afterTransactionCommit) {
            var executionResult = subscriber.afterTransactionCommit({
              connection: _this10.queryRunner.connection,
              queryRunner: _this10.queryRunner,
              manager: _this10.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "BEFORE_TRANSACTION_ROLLBACK" event.
     */
  }, {
    key: "broadcastBeforeTransactionRollbackEvent",
    value: function broadcastBeforeTransactionRollbackEvent(result) {
      var _this11 = this;
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (subscriber.beforeTransactionRollback) {
            var executionResult = subscriber.beforeTransactionRollback({
              connection: _this11.queryRunner.connection,
              queryRunner: _this11.queryRunner,
              manager: _this11.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_TRANSACTION_ROLLBACK" event.
     */
  }, {
    key: "broadcastAfterTransactionRollbackEvent",
    value: function broadcastAfterTransactionRollbackEvent(result) {
      var _this12 = this;
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (subscriber.afterTransactionRollback) {
            var executionResult = subscriber.afterTransactionRollback({
              connection: _this12.queryRunner.connection,
              queryRunner: _this12.queryRunner,
              manager: _this12.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_UPDATE" event.
     * After update event is executed after entity is being updated in the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastAfterUpdateEvent",
    value: function broadcastAfterUpdateEvent(result, metadata, entity, databaseEntity, updatedColumns, updatedRelations) {
      var _this13 = this;
      if (entity && metadata.afterUpdateListeners.length) {
        metadata.afterUpdateListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this13.isAllowedSubscriber(subscriber, metadata.target) && subscriber.afterUpdate) {
            var executionResult = subscriber.afterUpdate({
              connection: _this13.queryRunner.connection,
              queryRunner: _this13.queryRunner,
              manager: _this13.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              updatedColumns: updatedColumns || [],
              updatedRelations: updatedRelations || []
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_REMOVE" event.
     * After remove event is executed after entity is being removed from the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastAfterRemoveEvent",
    value: function broadcastAfterRemoveEvent(result, metadata, entity, databaseEntity) {
      var _this14 = this;
      if (entity && metadata.afterRemoveListeners.length) {
        metadata.afterRemoveListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this14.isAllowedSubscriber(subscriber, metadata.target) && subscriber.afterRemove) {
            var executionResult = subscriber.afterRemove({
              connection: _this14.queryRunner.connection,
              queryRunner: _this14.queryRunner,
              manager: _this14.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              entityId: metadata.getEntityIdMixedMap(databaseEntity)
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_SOFT_REMOVE" event.
     * After soft remove event is executed after entity is being soft removed from the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastAfterSoftRemoveEvent",
    value: function broadcastAfterSoftRemoveEvent(result, metadata, entity, databaseEntity) {
      var _this15 = this;
      if (entity && metadata.afterSoftRemoveListeners.length) {
        metadata.afterSoftRemoveListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this15.isAllowedSubscriber(subscriber, metadata.target) && subscriber.afterSoftRemove) {
            var executionResult = subscriber.afterSoftRemove({
              connection: _this15.queryRunner.connection,
              queryRunner: _this15.queryRunner,
              manager: _this15.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              entityId: metadata.getEntityIdMixedMap(databaseEntity)
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * Broadcasts "AFTER_RECOVER" event.
     * After recover event is executed after entity is being recovered in the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastAfterRecoverEvent",
    value: function broadcastAfterRecoverEvent(result, metadata, entity, databaseEntity) {
      var _this16 = this;
      if (entity && metadata.afterRecoverListeners.length) {
        metadata.afterRecoverListeners.forEach(function (listener) {
          if (listener.isAllowed(entity)) {
            var executionResult = listener.execute(entity);
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
      if (this.queryRunner.connection.subscribers.length) {
        this.queryRunner.connection.subscribers.forEach(function (subscriber) {
          if (_this16.isAllowedSubscriber(subscriber, metadata.target) && subscriber.afterRecover) {
            var executionResult = subscriber.afterRecover({
              connection: _this16.queryRunner.connection,
              queryRunner: _this16.queryRunner,
              manager: _this16.queryRunner.manager,
              entity: entity,
              metadata: metadata,
              databaseEntity: databaseEntity,
              entityId: metadata.getEntityIdMixedMap(databaseEntity)
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          }
        });
      }
    }
    /**
     * @deprecated Use `broadcastLoadForAllEvent`
     */
  }, {
    key: "broadcastLoadEventsForAll",
    value: function broadcastLoadEventsForAll(result, metadata, entities) {
      return this.broadcastLoadEvent(result, metadata, entities);
    }
    /**
     * Broadcasts "AFTER_LOAD" event for all given entities, and their sub-entities.
     * After load event is executed after entity has been loaded from the database.
     * All subscribers and entity listeners who listened to this event will be executed at this point.
     * Subscribers and entity listeners can return promises, it will wait until they are resolved.
     *
     * Note: this method has a performance-optimized code organization, do not change code structure.
     */
  }, {
    key: "broadcastLoadEvent",
    value: function broadcastLoadEvent(result, metadata, entities) {
      var _this17 = this;
      // Calculate which subscribers are fitting for the given entity type
      var fittingSubscribers = this.queryRunner.connection.subscribers.filter(function (subscriber) {
        return _this17.isAllowedSubscriber(subscriber, metadata.target) && subscriber.afterLoad;
      });
      if (metadata.relations.length || metadata.afterLoadListeners.length || fittingSubscribers.length) {
        // todo: check why need this?
        var nonPromiseEntities = entities.filter(function (entity) {
          return !(entity instanceof Promise);
        });
        // collect load events for all children entities that were loaded with the main entity
        if (metadata.relations.length) {
          metadata.relations.forEach(function (relation) {
            nonPromiseEntities.forEach(function (entity) {
              // in lazy relations we cannot simply access to entity property because it will cause a getter and a database query
              if (relation.isLazy && !entity.hasOwnProperty(relation.propertyName)) return;
              var value = relation.getEntityValue(entity);
              if (ObjectUtils.isObject(value)) _this17.broadcastLoadEvent(result, relation.inverseEntityMetadata, Array.isArray(value) ? value : [value]);
            });
          });
        }
        if (metadata.afterLoadListeners.length) {
          metadata.afterLoadListeners.forEach(function (listener) {
            nonPromiseEntities.forEach(function (entity) {
              if (listener.isAllowed(entity)) {
                var executionResult = listener.execute(entity);
                if (executionResult instanceof Promise) result.promises.push(executionResult);
                result.count++;
              }
            });
          });
        }
        fittingSubscribers.forEach(function (subscriber) {
          nonPromiseEntities.forEach(function (entity) {
            var executionResult = subscriber.afterLoad(entity, {
              entity: entity,
              metadata: metadata,
              connection: _this17.queryRunner.connection,
              queryRunner: _this17.queryRunner,
              manager: _this17.queryRunner.manager
            });
            if (executionResult instanceof Promise) result.promises.push(executionResult);
            result.count++;
          });
        });
      }
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Checks if subscriber's methods can be executed by checking if its don't listen to the particular entity,
     * or listens our entity.
     */
  }, {
    key: "isAllowedSubscriber",
    value: function isAllowedSubscriber(subscriber, target) {
      return !subscriber.listenTo || !subscriber.listenTo() || subscriber.listenTo() === Object || subscriber.listenTo() === target || subscriber.listenTo().isPrototypeOf(target);
    }
  }]);
  return Broadcaster;
}();